export function formatPnlOneDecimal(value: number, { showPositiveSign = false } = {}) {
  const roundedValue = Math.round(value * 10) / 10;
  const rounded = Object.is(roundedValue, -0) ? 0 : roundedValue;
  const sign = showPositiveSign && rounded > 0 ? '+' : '';
  const formatted = rounded.toLocaleString(undefined, {
    maximumFractionDigits: 1,
  });

  return `${sign}${formatted}`;
}

export function formatSignedPnlOneDecimal(value: number) {
  return formatPnlOneDecimal(value, { showPositiveSign: true });
}
